import { observer } from 'mobx-react';
import {
  NewBorrowerBaseballCard,
  StandardDialog,
} from '@roc/ui';

import { Document } from '@roc/feature-types';
import { useCreditReviewStore } from 'libs/feature-borrower-review/src/hooks/useCreditReviewStore';
import { useBorrowerBaseballCardStore } from 'libs/feature-borrowers/src/borrowers/hooks/useBorrowerBaseballCardStore';
import { CustomTaskDialog } from '@roc/feature-general-tasks';


interface BorrowerBaseballCardDialogProps {
  open: boolean;
  onClose: () => void;
  loanId: any;
  document: Document;
  taskId?: number;
}

export const NewBorrowerBaseballCardDialog = observer(({ open, onClose, loanId, document, taskId }: BorrowerBaseballCardDialogProps) => {
  const { borrowerBaseballCardStore } = useBorrowerBaseballCardStore();

  borrowerBaseballCardStore.currentBorrower = document?.borrowerId;
  borrowerBaseballCardStore.loanId = Number(document?.loanId);

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          maxWidth="xl"
          handleClose={onClose}
          title={
            `${borrowerBaseballCardStore.baseballCardDetails?.firstName} ${borrowerBaseballCardStore.baseballCardDetails?.lastName} - Track Record Review.`
          }
          dialogContent={
            <NewBorrowerBaseballCard store={borrowerBaseballCardStore}
              onClose={onClose}
              hideTitle={true}
              document={document}
            />
          }
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          maxWidth="xl"
          handleClose={onClose}
          title={
            `${borrowerBaseballCardStore.baseballCardDetails?.firstName} ${borrowerBaseballCardStore.baseballCardDetails?.lastName} - Track Record Review.`
          }
          removeContentBox
          dialogContent={
            <NewBorrowerBaseballCard store={borrowerBaseballCardStore}
              onClose={onClose}
              hideTitle={true}
              document={document}
            />
          }
        />
      )}
    </>)
});